import request from '@/utils/request'

const API_PREFIX = '/uni/homePage';

// 获取首页轮播图数据
export function getCarouselList(data) {
    return request({
        url:  `${API_PREFIX}/carousel/list`,
        method: 'get',
        data
    })
}

// 核心产品左侧图片
export function gertCoreProductImg(data) {
    return request({
        url:  `${API_PREFIX}/core/productImg`,
        method: 'get',
        data
    })
}

// 核心产品右侧产品
export function getCoreProductList(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/product/list`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 核心产品右侧产品
export function getProductType(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/productType`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 查询产品类型列表（用于菜单）
export function getProductTypeList() {
    return request({
        url: `${API_PREFIX}/productType/list`,
        method: 'get'
    })
}

// 查询首页行业列表
export function getWalkList(data) {
    return request({
        url:  `${API_PREFIX}/walks/list`,
        method: 'get',
        data
    })
}

// 核心产品右侧产品
export function getNewsActivityList(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/newsActivity/list`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 新闻详情
export function getNewsDetail(newsId) {
    return request({
        url: `/no-auth/news/list?id=` + newsId,
        method: 'get'
    })
}
// 各行各业详情
export function getWalksDetail(id) {
    return request({
        url: `/no-auth/walks/` + id,
        method: 'get'
    })
}

// 产品详情
export function getProductDetail(productId) {
    return request({
        url:`${API_PREFIX}/product/` + productId,
        method: 'get'
    })
}

// 产品详情
export function getProductDetailSys(id) {
    return request({
        url:`${API_PREFIX}/productSys/` + id,
        method: 'get'
    })
}

// 服务与维修联系方式
export function getContactInformation(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/contactInfo/list`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 查询维修服务标题文本
export function getRepairTitle(data) {
    return request({
        url:  `${API_PREFIX}/contactInfo/title`,
        method: 'post',
        data
    })
}


// 查询维修登记分组表列表
export function getRegisterGroupList(data) {
    return request({
        url:  `${API_PREFIX}/register/list`,
        method: 'post',
        data
    })
}

// 查询行业应用分类表列表
export function getIndustryTypeList() {
    return request({
        url:  `${API_PREFIX}/industry/type/list`,
        method: 'get',
    })
}

// 查询行业应用表列表
export function getIndustryList(data) {
    return request({
        url:  `${API_PREFIX}/industry/list`,
        method: 'post',
        data
    })
}

// 行业应用详情
export function getIndustryDetail(id) {
    return request({
        url: `${API_PREFIX}/industry/` + id,
        method: 'get'
    })
}

// 查询行业应用标题文本
export function getIndustryTitle(data) {
    return request({
        url: `${API_PREFIX}/industry/title/byOne`,
        method: 'post',
        data
    })
}

// 查询新闻活动分类列表
export function getNewsActivityFlagList() {
    return request({
        url: `${API_PREFIX}/newsActivity/flag/list`,
        method: 'get'
    })
}

// 查询新闻活动标题文本
export function getNewsActivityTitle(data) {
    return request({
        url: `${API_PREFIX}/newsActivity/title`,
        method: 'post',
        data
    })
}

// 关于我们
export function getAboutUsByOne(data) {
    return request({
        url:  `${API_PREFIX}/about/byOne`,
        method: 'post',
        data
    })
}

// 查询关于我们列表
export function listSysAboutUs(query) {
    return request({
        url: `${API_PREFIX}/data/list`,
        method: 'get',
        data: query,
    })
}

// 查询关于我们地图数据列表
export function listSysAboutUsAddress(query) {
    return request({
        url: `${API_PREFIX}/address/list`,
        method: 'get',
        data: query,
    })
}



// 服务与维修添加
export function registerAdd(data) {
    return request({
        url: `/uni/homePage/register/add`,
        method: 'post',
        data: data,
    })
}

export function homeTitleList() {
    return request({
        url: `/no-auth/homeTitle/listG`,
        method: 'get',
    })
}

export function homeSysReason() {
    return request({
        url: `/no-auth/sysReason/listG`,
        method: 'get',
    })
}

// 查询联系方式列表
export function getContactInfoList(query, pageReq) {
    return request({
        url: '/uni/contactUS/list',
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 查询联系方式标题文本
export function getContactInfoTitle(data) {
    return request({
        url: '/uni/contactUS/title',
        method: 'post',
        data
    })
}


export class getWalksdetail {
}

// 查询产品附件
export function getProductAttachment() {
    return request({
        url: `${API_PREFIX}/productAttachment`,
        method: 'get',
    })
}

// 根据产品ID查询属性分组数据
export function getProductAttributeGroups(productId) {
    return request({
        url: `${API_PREFIX}/product/${productId}/attributeGroups`,
        method: 'get',
    })
}

// 根据产品类型ID查询产品列表
export function listByProductType(productTypeId, pageReq) {
    return request({
        url: `${API_PREFIX}/product/listByProductType/${productTypeId}`,
        method: 'get',
        params: pageReq
    });
}
